var map = {
	"./Banner.block.tsx": 1203,
	"./Collection.block.tsx": 1204,
	"./CollectionsList.block.tsx": 1470,
	"./Divider.block.tsx": 1205,
	"./HtmlMarkup.block.tsx": 1206,
	"./MenuItem.block.tsx": 1207,
	"./Product.block.tsx": 1208,
	"./ProductsList.block.tsx": 1471,
	"./Slider.block.tsx": 1209,
	"./Timer.block.tsx": 1210,
	"./TwoButtons.block.tsx": 1211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1202;